module.exports = __webpack_public_path__ + "static/selectmark-multi-dont-c416233d142e184c37fbd29be2a82c46.png";